import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
  serviceProviderTypeDescriptions,
  ServiceProviderType
} from '../../service-provider-type.enum';

interface ServiceProviderSelection {
  type: ServiceProviderType;
  description: string;
  selected: boolean;
}

@Component({
  selector: 'app-services-search',
  templateUrl: './services-search.component.html',
  styleUrls: ['./services-search.component.scss']
})
export class ServicesSearchComponent implements OnInit {
  @Output() public providerTypes = new EventEmitter<ServiceProviderType[]>();
  @Output() public searchString = new EventEmitter<string>();

  public serviceProviderTypes: Array<ServiceProviderSelection> = [];
  constructor() {}

  get selectedProviderTypes(): Array<ServiceProviderType> {
    return this.serviceProviderTypes
      .filter(providerType => providerType.selected)
      .map(providerType => providerType.type);
  }

  public ngOnInit(): void {
    for (const serviceProvider of serviceProviderTypeDescriptions) {
      this.serviceProviderTypes.push({
        type: serviceProvider.enumValue,
        description: serviceProvider.description,
        selected: false
      });
    }
  }

  public toggleProviderType(providerIndex: number) {
    this.serviceProviderTypes[providerIndex].selected = true;
  }
}
